import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "src/context";
import { buildPagePrefixForUserData } from "src/hooks/useResponseRedirect";
import {
  CheckmarkCircle02Icon,
  CircleIcon,
  Edit02Icon,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@porchpass/ui";

interface ProgressListItemProps {
  text: string;
  status: boolean;
  url: string;
  borrowerId: string;
  applicationId: string;
  applicationStatus?: string;
  isDisabled?: boolean;
  editSectionClickHandler: (openLink: () => void) => void;
}
export default ({
  text,
  status,
  url,
  applicationId: application_id,
  borrowerId: borrower_id,
  applicationStatus,
  isDisabled,
  editSectionClickHandler,
}: ProgressListItemProps) => {
  const { setUserData } = useContext(UserContext);
  const navigate = useNavigate();
  const prefixedUrl = `${buildPagePrefixForUserData({ application_id, borrower_id })}${url}`;
  const openLink = () => {
    setUserData?.((prev) => ({
      ...prev,
      application_id,
      borrower_id,
    }));
    navigate(prefixedUrl);
  };

  const handleRowClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (isDisabled) return;

    if (applicationStatus !== "STARTED") {
      editSectionClickHandler(openLink);
    } else {
      openLink();
    }
  };

  const row = (
    <button
      type="button"
      className={`box-border my-1 flex w-full items-center gap-3 rounded-lg border-0 bg-transparent p-2 text-left ${
        isDisabled
          ? "cursor-not-allowed opacity-25"
          : "cursor-pointer hover:bg-[rgba(240,241,244,0.8)] focus-visible:outline focus-visible:outline-revert [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:shadow-[0_0_0_2px_Highlight] [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:outline-none [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:outline-offset-2 [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:shadow-[0_0_0_2px_Highlight] [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:outline-none [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:outline-offset-2"
      }`}
      disabled={isDisabled}
      onClick={handleRowClick}
      data-replay-safe
      aria-label={`Edit ${text}`}
    >
      <div className="flex shrink-0 items-center justify-center">
        {status ? (
          <CheckmarkCircle02Icon size={20} className="text-[#00b27c]" />
        ) : (
          <CircleIcon size={20} className="text-[#d2d5db]" />
        )}
      </div>
      <span className="flex-1 text-sm leading-5">{text}</span>
      <div
        className="flex shrink-0 items-center justify-center"
        aria-hidden="true"
      >
        <Edit02Icon size={12} />
      </div>
    </button>
  );

  if (applicationStatus === "REVIEWED" && isDisabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="block w-full">{row}</span>
          </TooltipTrigger>
          <TooltipContent>
            Your application is being reviewed and cannot be edited at this
            time.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return row;
};
